import React, {useEffect, useState} from 'react';
import {Button, Form} from 'react-bootstrap';
import {useHistory, useParams} from "react-router-dom";
import {Formik} from "formik";
import {FormikControl} from "./Components";
import API from "../services/API";
import {Validation} from "../commons/Utils";
import Notifications from "./Notifications";
import Login from "./Login";
import documaster_logo from "../styles/images/documaster.png";

/**
 * Publiczna strona ustawiania hasła z linku wysłanego e-mailem. Token z adresu jest tu
 * jedynym poświadczeniem, więc strona nie wymaga zalogowania.
 */
const SetPassword = () => {

    const { token } = useParams();
    const history = useHistory();
    const [info, setInfo] = useState(null);
    const [failure, setFailure] = useState(null);

    useEffect(() => {
        API.getPasswordTokenInfo(token)
            .then(setInfo)
            //błąd serwera to co innego niż zużyty link i nie wolno go pokazywać jako to samo
            .catch(e => setFailure(typeof e === 'string' ? e : 'Nie udało się sprawdzić linku'));
    }, [token]);

    const validate = (values) => {
        let err = {};
        Validation.add(err, 'password', Validation.present(values.password, 'Hasło jest wymagane'));
        Validation.add(err, 'password', Validation.length(values.password, 8, 'Hasło musi mieć co najmniej 8 znaków'));
        Validation.add(err, 'passwordRepeat', Validation.present(values.passwordRepeat, 'Powtórz hasło'));
        if (values.password && values.passwordRepeat) {
            const eq = Validation.equal(values.password, values.passwordRepeat, 'Hasła nie są takie same');
            Validation.add(err, 'password', eq);
            Validation.add(err, 'passwordRepeat', eq);
        }
        return err;
    }

    const submit = (values, {setSubmitting}) => {
        setSubmitting(true);
        API.setPasswordWithToken({token, password: values.password}).then(() => {
            Notifications.pushNew('Hasło zostało ustawione, możesz się zalogować', 'info');
            history.push(Login.url);
        }).catch(e => {
            setSubmitting(false);
            Notifications.pushNew(e, 'danger');
        });
    }

    const frame = (children) => <div className="login-page">
        <div className="login-brand">
            <img className="login-logo" src={documaster_logo} alt="Documaster"/>
            <div className="login-product">GlobalService</div>
        </div>
        <div className="login-card">{children}</div>
    </div>;

    if (failure) return frame(<>
        <h1 className="login-card-title">Nie udało się sprawdzić linku</h1>
        <p className="text-danger">{failure}</p>
        <p>Spróbuj ponownie za chwilę. Jeśli to nie pomoże, zgłoś to administratorowi.</p>
    </>);

    if (info === null) return frame(<p>Sprawdzanie linku...</p>);

    if (!info.valid) return frame(<>
        <h1 className="login-card-title">Link jest nieaktywny</h1>
        <p>Ten link wygasł albo został już użyty. Poproś administratora o wysłanie nowego.</p>
        <Button variant="outline-secondary" onClick={() => history.push(Login.url)}>Przejdź do logowania</Button>
    </>);

    return frame(<>
        <h1 className="login-card-title">Ustaw hasło</h1>
        <p>Konto: <strong>{info.login}</strong></p>
        <Formik initialValues={{password: '', passwordRepeat: ''}} onSubmit={submit} validate={validate}>
            {({handleSubmit, isSubmitting}) => (
                <Form noValidate onSubmit={handleSubmit} className="login-form">
                    <Form.Group controlId="passwordId">
                        <Form.Label>Nowe hasło</Form.Label>
                        <FormikControl type="password" autoFocus name="password" placeholder="••••••••"/>
                    </Form.Group>
                    <Form.Group controlId="passwordRepeatId">
                        <Form.Label>Powtórz hasło</Form.Label>
                        <FormikControl type="password" name="passwordRepeat" placeholder="••••••••"/>
                    </Form.Group>
                    <Button variant="primary" type="submit" disabled={isSubmitting}>Ustaw hasło</Button>
                </Form>
            )}
        </Formik>
    </>);
}

export default SetPassword;

SetPassword.basePath = '/setPassword';
SetPassword.url = `${SetPassword.basePath}/:token`;
